import { UserInDto } from '../../../types/user.dto'

export const GET_CURRENT_USER = 'GET_CURRENT_USER'
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS'
export const GET_CURRENT_USER_ERROR = 'GET_CURRENT_USER_ERROR'

export const RESET_CURRENT_USER = 'RESET_CURRENT_USER'

export const SET_USER = 'SET_USER'
export const SET_USER_SUCCESS = 'SET_USER_SUCCESS'
export const SET_USER_ERROR = 'SET_USER_ERROR'

export interface GetCurrentUser {
  type: typeof GET_CURRENT_USER
  payload: null
}

export interface GetCurrentUserSuccess {
  type: typeof GET_CURRENT_USER_SUCCESS
  payload: UserInDto
}

export interface GetCurrentUserError {
  type: typeof GET_CURRENT_USER_ERROR
  payload: boolean | string
}

export interface ResetCurrentUser {
  type: typeof RESET_CURRENT_USER
  payload: null
}

export interface State {
  data: UserInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetCurrentUser | GetCurrentUserSuccess | GetCurrentUserError | ResetCurrentUser
